var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.6,26.3h-2.2v-10.9s0-2.6,3.7-2.4,17.8,0,17.8,0c0,0,2.7,0,3.3,2s1,3.6,1,3.6c0,0,3.5.8,3.5,3.7s0,4.1,0,4.1h-3.5",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeMiterlimit: 10,
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25 13.3 25 18.7 30.1 18.7",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeMiterlimit: 10,
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.7,
    y1: 19.2,
    x2: 8.6,
    y2: 19.2,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeMiterlimit: 10,
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.7,
    y1: 22.2,
    x2: 8.6,
    y2: 22.2,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeMiterlimit: 10,
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.2,
    y1: 22.2,
    x2: 33.6,
    y2: 22.2,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeMiterlimit: 10,
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7,
    cy: 26.2,
    r: 2.2,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeMiterlimit: 10,
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.1,
    cy: 26.3,
    r: 2.2,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeMiterlimit: 10,
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.9,
    y1: 26.2,
    x2: 25.8,
    y2: 26.2,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeMiterlimit: 10,
      strokeWidth: "1.3px"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/book-icon.4044f8e31fd99a8501e9a4bde09eb27d.svg";
export { ForwardRef as ReactComponent };